import { render, staticRenderFns } from "./ProjectDevelopers.vue?vue&type=template&id=7726c5a0&scoped=true&"
import script from "./ProjectDevelopers.vue?vue&type=script&lang=js&"
export * from "./ProjectDevelopers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7726c5a0",
  null
  
)

export default component.exports